import { useCallback, useEffect } from 'react';
import { Location, useLocation } from 'react-router';

export const useScrollMemory: (isLoading: boolean) => void = (isLoading: boolean): void => {
  const { pathname }: Location = useLocation();

  useEffect((): void => {
    if (isLoading) {
      return;
    }
    const savedScroll: number = Number(sessionStorage.getItem(pathname) || 0);
    requestAnimationFrame((): void => window.scrollTo(0, savedScroll));
  }, [pathname, isLoading]);

  const setScrollValueStorage: () => void = useCallback((): void => {
    if (!isLoading) {
      sessionStorage.setItem(pathname, String(window.scrollY));
    }
  }, [pathname, isLoading]);

  useEffect(() => {
    window.addEventListener('scroll', setScrollValueStorage);

    return (): void => {
      window.removeEventListener('scroll', setScrollValueStorage);
    };
  }, [setScrollValueStorage]);
};
